<template>
  <!-- TODO: 访客轨迹路径 -->
  <div id="bd-info">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="crm" label="CRM">
        <bd-crm></bd-crm>
      </el-tab-pane>
      <el-tab-pane name="fingerpints" label="设备">
        <bd-finger-print></bd-finger-print>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import BdCrm from './BdCrm'
import BdFingerPrint from './BdFingerPrint'

export default {
  name: "bd-info",
  components: { BdCrm, BdFingerPrint },
  data() {
    return {
      activeName: "crm"
    };
  },
  methods: {
    ...mapActions([ "updateRightActiveTab" ]),
    handleClick(tab, event) {
      // console.log('1 tab:', tab.name)
      this.updateRightActiveTab(tab.name)
      if (tab.name === "crm") {
        //
      } else if (tab.name === "fingerpints") {
        //
      }
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
</style>